import React from 'react'

const SlideSchedule = () => (
  <div className="slide">
    <div className="slide-inner">
      <div className="slide-left">
        <h2>ZERO Schedule</h2>
        <p>ZERO will begin with a 25m initial distribution to those community members who registered with us before Christmas day. Starting December 30th, 2020, for two weeks, liquidity providers to the Uniswap ZERO/ETH pool will be eligible to mine 100m ZERO tokens prior to the release of the ERC20 to ZERO bridge (on Avalanche blockchain), where the mainnet contracts will be deployed. Over the next 4 years 750m ZERO will be available for liquidity mining.</p>
      </div>
      <div className="slide-right">
        <img src="/zero-schedule.png" alt="Zero Schedule" />
      </div>
    </div>
  </div>
)

export default SlideSchedule
